export const iconFontAwesomeEditingSquareCheck = (
	<i className="fa-solid fa-square-check"></i>
);
